import { Link } from "react-router-dom";
import LegalLayout, { LegalSection } from "../components/LegalLayout";
import Seo from "../components/Seo";

export default function Confidentialite() {
  return (
    <LegalLayout
      eyebrow="RGPD"
      title={<>Politique de <span className="text-outline">confidentialité</span></>}
      updated="Juillet 2026"
      intro="ML. Agence Web accorde une grande importance à la protection de vos données personnelles. Cette politique explique quelles données sont collectées, pourquoi, comment elles sont protégées, et quels sont vos droits, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés."
    >
      <Seo title="Politique de confidentialité" description="Comment ML. Agence Web collecte, utilise et protège vos données personnelles, conformément au RGPD." />
      <LegalSection title="Responsable du traitement">
        <p>Le responsable du traitement des données est ML. Agence Web. Pour toute question relative à vos données, contactez : <a href="mailto:ml.agence04@gmail.com" className="text-[var(--accent)] hover:underline">ml.agence04@gmail.com</a>.</p>
      </LegalSection>

      <LegalSection title="Données collectées">
        <p>Nous ne collectons que les données strictement nécessaires :</p>
        <ul className="space-y-2 list-none">
          <li>• <strong>Formulaires</strong> (contact, aperçu gratuit, audit) : nom ou nom du commerce, email, téléphone (facultatif), secteur d'activité, présence en ligne, message et réponses au quiz.</li>
          <li>• <strong>Espace client</strong> : email de connexion, nom, messages échangés, fichiers déposés, avancement et statut de votre projet.</li>
          <li>• <strong>Mesure d'audience</strong> : données de navigation anonymisées (pages vues, appareil, provenance) via Vercel Web Analytics — <em>sans cookie</em> ; et, uniquement si vous y consentez, des statistiques d'usage plus détaillées (Microsoft Clarity et/ou Google Analytics).</li>
        </ul>
      </LegalSection>

      <LegalSection title="Finalités & bases légales">
        <ul className="space-y-2 list-none">
          <li>• Répondre à vos demandes et vous recontacter — base : votre <strong>consentement</strong> et/ou l'intérêt légitime.</li>
          <li>• Gérer la relation client et le suivi de projet (espace client) — base : <strong>exécution du contrat</strong>.</li>
          <li>• Améliorer le site et mesurer l'audience — base : <strong>intérêt légitime</strong> (audience anonyme) ou <strong>consentement</strong> (outils avec cookies).</li>
        </ul>
      </LegalSection>

      <LegalSection title="Destinataires des données">
        <p>Vos données sont destinées à ML. Agence Web uniquement. Elles ne sont <strong>jamais vendues ni cédées</strong>. Elles peuvent être traitées par nos sous-traitants techniques strictement pour le fonctionnement du service : Vercel (hébergement), Supabase (base de données, authentification, stockage), Resend (envoi d'emails). Ces prestataires agissent selon nos instructions et présentent des garanties conformes au RGPD.</p>
      </LegalSection>

      <LegalSection title="Durée de conservation">
        <ul className="space-y-2 list-none">
          <li>• Prospects / leads : jusqu'à 3 ans après le dernier contact.</li>
          <li>• Clients : pendant toute la durée de la relation, puis selon les obligations légales (documents comptables : 10 ans).</li>
          <li>• Données de mesure d'audience : selon la durée propre à chaque outil (généralement 14 à 25 mois).</li>
        </ul>
      </LegalSection>

      <LegalSection title="Transferts hors Union européenne">
        <p>Certains prestataires (Vercel, Supabase) peuvent héberger ou traiter des données en dehors de l'UE (notamment aux États-Unis). Ces transferts sont encadrés par des garanties appropriées (clauses contractuelles types de la Commission européenne).</p>
      </LegalSection>

      <LegalSection title="Sécurité">
        <p>Les données sont protégées par des mesures techniques adaptées : chiffrement des échanges (HTTPS), cloisonnement strict des accès par utilisateur (règles de sécurité au niveau de la base de données), connexion à l'espace client par lien magique (sans mot de passe à stocker), et accès aux fichiers via des liens temporaires signés.</p>
      </LegalSection>

      <LegalSection title="Vos droits">
        <p>Conformément au RGPD, vous disposez des droits suivants : accès, rectification, effacement, opposition, limitation du traitement, et portabilité de vos données. Vous pouvez également retirer votre consentement à tout moment.</p>
        <p>Pour exercer ces droits, écrivez à <a href="mailto:ml.agence04@gmail.com" className="text-[var(--accent)] hover:underline">ml.agence04@gmail.com</a>. Vous disposez enfin du droit d'introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-[var(--accent)] hover:underline">cnil.fr</a>).</p>
      </LegalSection>

      <LegalSection title="Cookies">
        <p>La gestion des cookies et traceurs est détaillée dans notre <Link to="/cookies" className="text-[var(--accent)] hover:underline">Politique de gestion des cookies</Link>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
